<template>
  <div v-if="customMenus.length > 0">
    <!-- <div id="customMenu" class="language-control-menu" v-if="params.languageMenuActivate"  style="cursor: pointer; ">
      <div v-if="getAvailableLang('spanish')" @click="setTypeLanguageMenu('spanish')" style="margin-right: 5px;" :style="{fontWeight: (multiLanguage === 'spanish') ? '600' : 'unset'}">ES</div>
      <div v-if="(getAvailableLang('spanish') && getAvailableLang('french')) || (getAvailableLang('spanish') && getAvailableLang('english'))">/</div>
      <div v-if="getAvailableLang('english')" @click="setTypeLanguageMenu('english')" style="margin-left: 5px;margin-right: 5px;" :style="{fontWeight: (multiLanguage === 'english') ? '600' : 'unset'}">EN</div>
      <div v-if="(getAvailableLang('english') && getAvailableLang('french') && getAvailableLang('spanish')) || (getAvailableLang('english') && getAvailableLang('french') && !getAvailableLang('spanish'))" >/</div>
      <div v-if="getAvailableLang('french')" @click="setTypeLanguageMenu('french')" style="margin-left: 5px;" :style="{fontWeight: (multiLanguage === 'french') ? '600' : 'unset'}">FR</div>
    </div> -->
    <div
      :class="menuCustom(i, customMenu)"
      :key="'menuCustom-' + i"
      class="background-custom-menu"
      id="menuCustom"
      v-for="(customMenu, i) in customMenus"
    >
      <div class="container_menu">
        <div class="logo_menu justify-content-center">
          <div class="text-center">
            <div class="img-restaurant" :style="{ 'background-image': `url('${customMenu.logo}')` }"></div>
          </div>
        </div>
        <div class="columns justify-content-center mx-0">
          <div class="carousel_categories" v-if="getCategoriesByLang(customMenu).length > 1">
            <div class="container_icon_row mb-1">
              <i
                :class="{'disabled':!rowLeft}"
                @click="scrollCategories('left')"
                class="mdi-icon-arrow-left-cm icon-arrow-left-cm"
              ></i>
            </div>
            <div @scroll="scrollingCategories()" class="container_categories">
              <div :key="index" v-for="(category, index) in getCategoriesByLang(customMenu)">
                <button
                  :class="{'start': index === 0, 'end': index === customMenu.categories.length - 1, 'unique': customMenu.categories.length == 1}"
                  :id="'buttonCategory-' + index"
                  @click="
                      changeCategory(
                        category._id,
                        category.typeCategory,
                        i,
                        customMenu.buttonColorBorder,
                        index,
                        customMenu.buttonColorLetter
                      ), centerSelected($event)
                    "
                  class="button-custom"
                  size="is-medium"
                  style="width: max-content; cursor: pointer;"
                  v-if="getNameDescriptionImgPriceOneImgPriceTwoWithLang(category, 'name')"
                >
                  <i
                    class="icons_menu icon_recommended category_icon"
                    v-if="category.recommended == 1"
                  ></i>
                  {{ getNameDescriptionImgPriceOneImgPriceTwoWithLang(category, 'name') }}
                </button>
              </div>
            </div>
            <div class="container_icon_row mb-1">
              <i
                :class="{'disabled':!rowRight}"
                @click="scrollCategories('right')"
                class="mdi-icon-arrow-right-cm icon-arrow-right-cm"
              ></i>
            </div>
          </div>
        </div>
        <div class="container_description">
          <div class="description_category" v-if="descriptionCategory !== null">
            <p
              class="description-category"
              id="categoryDescription"
              v-html="textFormat(getNameDescriptionImgPriceOneImgPriceTwoWithLang(descriptionCategory, 'description'))"
            ></p>
          </div>
          <div class="container_banner" v-if="bannerCategory != null && bannerCategory !== ''">
            <div class="banner_category banner_description">
              <div :style="`background-image: url('${bannerCategory}');`"></div>
            </div>
          </div>
        </div>
        <div
          :class="{'dn': (imagePriceOne === null || imagePriceOne === undefined) && isTwoPrices !== true && descriptionCategory != null}"
          class="columns content_banner_icons is-mobile is-multiline"
          v-if="
            getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo') !== null &&
            getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo') !== undefined &&
            getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') !== null &&
            getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') !== undefined ||
            viewIcons === true"
        >
          <div class="column my-2 is-5 container_icons is-offset-9 is-align-items-flex-end">
            <div
              class="container_img_prices"
              v-if="getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo')  !== null && getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo')  !== undefined && isTwoPrices === true"
            >
              <img :src="`${getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo')}`" class="img_prices img_price2" />
            </div>
            <div
              class="container_img_prices"
              v-if="(getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo')  === null || getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceTwo, 'imagePriceTwo')  === undefined) && viewIcons === true && isTwoPrices === true"
            >
              <img class="img_prices img_price2" src="@/assets/images/icons/icon_cup.svg" />
            </div>
            <div
              class="container_img_prices"
              v-if="getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') !== null && getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') !== undefined && getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') !== null"
            >
              <img :src="`${getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne')}`" class="img_prices img_price1" id="imagePriceOne"/>
            </div>
            <div
              class="container_img_prices"
              v-if="(getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') === null || getNameDescriptionImgPriceOneImgPriceTwoWithLang(imagePriceOne, 'imagePriceOne') === undefined) && viewIcons === true && isTwoPrices === true"
            >
              <img class="img_prices img_price1" id="imagePriceOneAssets" src="@/assets/images/icons/icon_bottle.svg" />
            </div>
          </div>
        </div>
        <div class="container-with-logos-fix">
          <div class="container_products">
            <div class="content-list-products" v-if="productsRecommended.length > 0">
              <div class="columns list_products">
                <div class="column is-8 list_categories">
                  <div class="list-category list-title-category-border list-category__recommended-section">
                    <div class="list-title-category list-title-category-border">
                      <i class="icons_menu icon_recommended category_icon subcategory_icon"></i>
                      <h3 class="text-bold title-sub-category" id="subCategory">RECOMENDADOS</h3>
                    </div>
                    <div
                      :key="'product-' + product._id + '-' + indexProduct"
                      class="columns is-mobile list-content-category"
                      v-for="(product, indexProduct) in productsRecommended"
                    >
                      <div
                        :class="{'is-7 is-7-mobile': product.priceTwo !== null && product.priceTwo > 0
                      && isTwoPrices === true, 'is-10 is-10-mobile': product.priceTwo === null ||
                      product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true,
                      'container_icon_product': !product.image && product.recommended,}"
                        class="column is-7 is-7-mobile list-item-category pt-0 pl-0"
                        v-if="
                        product.isImage == 0 ||
                        product.isImage == undefined ||
                        product.isImage == null
                      "
                      >
                        <div
                          :class="{
                          icon_product: !product.image && product.recommended,
                        }"
                          class="container_img"
                          v-if="(product.image || product.recommended) && getProductNameByLang(product)"
                        >
                          <div
                            @click="openImage(getProductsImageLang(product, 'image'))"
                            class="img_product"
                            :style="{ 'background-image': `url('${getProductsImageLang(product, 'image')}')`}"
                            v-if="getProductsImageLang(product, 'image')"
                          >
                            <div class="container_icon" v-if="product.recommended">
                              <i class="icons_menu icon_recommended icon_products"></i>
                            </div>
                          </div>
                          <i
                            class="icons_menu icon_recommended icon_products"
                            v-if="product.recommended && !getProductsImageLang(product, 'image')"
                          ></i>
                        </div>
                        <div class="container_product">
                          <div class="container_title">
                            <label class="title-product" id="product">
                              {{
                                getProductNameByLang(product)
                              }}
                            </label>
                          </div>
                          <div
                            class="description-product"
                            id="productDescription"
                            v-html="textFormat(getProductDescriptionByLang(product))"
                          >
                          </div>
                          <section class="iconsContainer">
                            <span  class="logoDietaryRestrictions" v-for="(restriction,index) in product.dietaryRestrictions" :style="{'mask-image':`url(${restriction.iconURL})`}" :key="index"></span>
                          </section>
                        </div>
                      </div>
                      <div
                        :class="{'is-5 is-5-mobile': product.priceTwo !== null && product.priceTwo > 0
                      && isTwoPrices === true, 'is-2 is-2-mobile': product.priceTwo === null ||
                      product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                        class="column list-item-category p-0 prices"
                        v-if="
                        product.isImage == 0 ||
                        product.isImage == undefined ||
                        product.isImage == null
                      "
                      >
                        <label
                          class="price-product price_two"
                          v-if="product.priceTwo !== null && product.priceTwo > 0 && isTwoPrices === true && product.typePrice === 'COP'"
                        >
                          {{ product.priceTwo | currency((vendor.id === 900) ? '€ ' : '$ ', 0, { thousandsSeparator: "," }) }}
                        </label>
                        <label
                          class="price-product price_two"
                          v-if="product.priceTwo !== null && product.priceTwo > 0 && isTwoPrices === true && product.typePrice === 'USD'"
                        >
                          {{ (vendor.id === 900) ? '€ ' : '$ ' + product.priceTwo }}
                        </label>
                        <label
                          :class="{'only_one': product.priceTwo === null ||
                        product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                          class="price-product price_one"
                          v-if="(parseInt(product.price) > 0) && product.typePrice === 'COP'"
                        >
                          {{ product.price | currency((vendor.id === 900) ? '€ ' : '$ ', 0, { thousandsSeparator: "," }) }}
                        </label>
                        <label
                          :class="{'only_one': product.priceTwo === null ||
                        product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                          class="price-product price_one"
                          v-if="(parseInt(product.price) > 0) && product.typePrice === 'USD'"
                        >
                          {{ (vendor.id === 900) ? '€ ' : '$ ' +  product.price }}
                        </label>
                        <label
                          :class="{'only_one': product.priceTwo === null ||
                        product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                          class="price-product price_one"
                          v-if="(parseInt(product.price) === 0)"
                        >------------</label>
                      </div>
                      <div class="column is-12 is-12-mobile p-0" v-if="product.isImage == 1">
                        <img :src="`${getProductsImageLang(product, 'onlyImage')}`" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="content-list-products" v-if="customMenu.products.length > 0">
              <div
                :key="'cataloge-' + item.subCategoryName + '-' + indexCustom"
                class="columns list_products"
                v-for="(item, indexCustom) in customMenu.products"
              >
                <div class="column is-8 list_categories">
                  <div class="list-category">
                    <div
                      :class="{'list-title-category-border': item.subCategoryName != '' || productsRecommended.length > 0}"
                      class="list-title-category sub sub-aux"
                      v-if="getNameDescriptionCategorySubcategoryByLang(item, 'name')"
                    >
                      <div class="cont_subcategory">
                        <i
                          class="icons_menu icon_recommended category_icon subcategory_icon"
                          v-if="item.subCategoryRecommended == 1"
                        ></i>
                        <h3
                          class="text-bold title-sub-category"
                          id="subCategory"
                        >{{ getNameDescriptionCategorySubcategoryByLang(item, 'name') }}</h3>
                      </div>
                      <div v-if="getNameDescriptionCategorySubcategoryByLang(item, 'description')">
                        <p
                          class="description-subcategory"
                          id="subCategoryDescription"
                          v-html="textFormat(getNameDescriptionCategorySubcategoryByLang(item, 'description'))"
                        ></p>
                      </div>
                    </div>
                    <div
                      :key="'product-' + product._id + '-' + indexProduct"
                      class="columns is-mobile list-content-category"
                      v-for="(product, indexProduct) in item.products"
                    >
                      <div
                        :class="{'is-7 is-7-mobile': product.priceTwo !== null && product.priceTwo > 0
                      && isTwoPrices === true, 'is-10 is-10-mobile': product.priceTwo === null ||
                      product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true,
                      'container_icon_product': !product.image && product.recommended,}"
                        class="column is-7 is-7-mobile list-item-category pt-0 pl-0"
                        v-if="
                        (product.isImage == 0 ||
                        product.isImage == undefined ||
                        product.isImage == null) &&
                        getProductNameByLang(product)
                      "
                      >
                        <div
                          :class="{
                          icon_product: !product.image && product.recommended,
                        }"
                          class="container_img"
                          v-if="(product.image || product.recommended) && getProductNameByLang(product)"
                        >
                          <div
                            @click="openImage(getProductsImageLang(product, 'image'))"
                            class="img_product"
                            :style="{ 'background-image': `url('${getProductsImageLang(product, 'image')}')`}"
                            v-if="getProductsImageLang(product, 'image')"
                          >
                            <div class="container_icon" v-if="product.recommended">
                              <i class="icons_menu icon_recommended icon_products"></i>
                            </div>
                          </div>
                          <i
                            class="icons_menu icon_recommended icon_products"
                            v-if="product.recommended && !getProductsImageLang(product, 'image')"
                          ></i>
                        </div>
                        <div class="container_product">
                          <div class="container_title">
                            <label class="title-product" id="product">
                              {{
                                getProductNameByLang(product)
                              }}
                            </label>
                          </div>
                          <div
                            class="description-product"
                            id="productDescription"
                            v-html="textFormat(getProductDescriptionByLang(product))"
                          ></div>
                          <section class="iconsContainer">
                                      <span  class="logoDietaryRestrictions" v-for="(restriction,index) in product.dietaryRestrictions" :style="{'mask-image':`url(${restriction.iconURL})`}" :key="index"></span>
                          </section>
                        </div>
                      </div>
                      <div
                        :class="{'is-5 is-5-mobile': product.priceTwo !== null && product.priceTwo > 0
                      && isTwoPrices === true, 'is-2 is-2-mobile': product.priceTwo === null ||
                      product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                        class="column list-item-category p-0 prices"
                        v-if="
                        (product.isImage == 0 ||
                        product.isImage == undefined ||
                        product.isImage == null) &&
                        getProductNameByLang(product)

                      "
                      >
                        <label
                          class="price-product price_two"
                          v-if="product.priceTwo !== null && product.priceTwo > 0 && isTwoPrices === true && product.typePrice === 'COP'"
                        >
                          {{ product.priceTwo | currency((vendor.id === 900) ? '€ ' : '$ ', 0, { thousandsSeparator: "," }) }}
                        </label>
                        <label
                          class="price-product price_two"
                          v-if="product.priceTwo !== null && product.priceTwo > 0 && isTwoPrices === true && product.typePrice === 'USD'"
                        >
                          {{ (vendor.id === 900) ? '€ ' : '$ ' + product.priceTwo }}
                        </label>
                        <label
                          :class="{'only_one': product.priceTwo === null ||
                        product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                          class="price-product price_one"
                          v-if="(parseInt(product.price) > 0) && product.typePrice === 'COP'"
                        >
                          {{ product.price | currency((vendor.id === 900) ? '€ ' : '$ ', 0, { thousandsSeparator: "," }) }}
                        </label>
                        <label
                          :class="{'only_one': product.priceTwo === null ||
                        product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                          class="price-product price_one"
                          v-if="(parseInt(product.price) > 0) && product.typePrice === 'USD'"
                        >
                          {{ (vendor.id === 900) ? '€ ' : '$ ' + product.price }}
                        </label>
                        <label
                          :class="{'only_one': product.priceTwo === null ||
                        product.priceTwo <= 0 || product.priceTwo === undefined || isTwoPrices !== true}"
                          class="price-product price_one"
                          v-if="(parseInt(product.price) === 0)"
                        >------------</label>
                      </div>
                      <div class="column is-12 is-12-mobile p-0" v-if="product.isImage == 1">
                        <img :src="`${getProductsImageLang(product, 'onlyImage')}`" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <section class="logosExplanation">
            <div v-for="restriction in restrictions" :key="restriction._id" class="dietaryRestrictions">
              <span  class="logoDietaryRestrictions"  :style="{'mask-image':`url(${restriction.iconURL})`}"></span>
              <p>{{restriction.name}}</p>
            </div>
          </section>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import modalMenuImg from '@/components/menuDigital/modalMenuImg';
import MainApi from '@/helpers/apis/baseApi.js';
import globalTypes from '@/store/types/global';
export default {
  props: ['menuId', 'typeLanguage'],
  data () {
    return {
      restrictions: [],
      values: 0,
      customMenus: [],
      catalogeItems: [],
      imagePriceOne: null,
      imagePriceTwo: null,
      bannerCategory: null,
      descriptionCategory: null,
      viewIcons: false,
      isTwoPrices: false,
      scrollLeft: 0,
      productsRecommended: [],
      rowLeft: true,
      rowRight: true
    };
  },
  mounted () {
    /* if (this.params.languageMenuActivate && this.params.availableLanguages) {
      const orderLangs = this.params.availableLanguages.split(',').sort((a, b) => {
        const order = { spanish: 1, english: 2, french: 3 };
        return (order[a] || 0) - (order[b] || 0);
      });
      if (this.multiLanguage !== orderLangs[0]) {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, this.multiLanguage);
      } else {
        this.$store.commit(globalTypes.mutations.setMultiLanguage, orderLangs[0]);
      }
    } */
    this.getDietaryRestrictions();
    this.getViewMenus();
  },
  updated () {
    if (this.customMenus.length > 0) {
      this.colorArrows();
    }
  },
  destroyed () {
    this.deleteElement();
  },
  computed: {
    getCategoriesByLang () {
      return (customMenu) => {
        const customMenuTemp = customMenu;
        if (customMenuTemp) {
          if (this.multiLanguage === 'spanish') {
            return customMenuTemp.categories.filter((category) => (category.name ? category.name : category.nameEnglish));
          }
          if (this.multiLanguage === 'english') {
            return customMenuTemp.categories.filter((category) => (category.nameEnglish ? category.nameEnglish : category.name));
          }
          if (this.multiLanguage === 'french') {
            return customMenuTemp.categories.filter((category) => (category.nameFrench ? category.nameFrench : category.name));
          }
        }
      };
    },
    getNameDescriptionImgPriceOneImgPriceTwoWithLang () {
      return (category, type) => {
        if (category !== null) {
          switch (type) {
            case 'name':
              if (this.multiLanguage === 'spanish') {
                return category.name ? category.name : category.nameEnglish;
              }
              if (this.multiLanguage === 'english') {
                return category.nameEnglish ? category.nameEnglish : category.name;
              }
              if (this.multiLanguage === 'french') {
                return category.nameFrench ? category.nameFrench : category.name;
              }
              break;
            case 'description':
              if (this.multiLanguage === 'spanish') {
                return category.description ? category.description : category.descriptionEnglish;
              }
              if (this.multiLanguage === 'english') {
                return category.descriptionEnglish ? category.descriptionEnglish : category.description;
              }
              if (this.multiLanguage === 'french') {
                return category.descriptionFrench ? category.descriptionFrench : category.description;
              }
              break;
            case 'imagePriceOne':
              if (this.multiLanguage === 'spanish') {
                return category.imagePriceOne ? category.imagePriceOne : category.imagePriceOneEnglish;
              }
              if (this.multiLanguage === 'english') {
                return category.imagePriceOneEnglish ? category.imagePriceOneEnglish : category.imagePriceOne;
              }
              if (this.multiLanguage === 'french') {
                return category.imagePriceOneFrench ? category.imagePriceOneFrench : category.imagePriceOne;
              }
              break;
            case 'imagePriceTwo':
              if (this.multiLanguage === 'spanish') {
                return category.imagePriceTwo ? category.imagePriceTwo : category.imagePriceTwoEnglish;
              }
              if (this.multiLanguage === 'english') {
                return category.imagePriceTwoEnglish ? category.imagePriceTwoEnglish : category.imagePriceTwo;
              }
              if (this.multiLanguage === 'french') {
                return category.imagePriceTwoFrench ? category.imagePriceTwoFrench : category.imagePriceTwo;
              }
              break;
            default:
              return null;
          }
        } else {
          return null;
        }
      };
    },
    getProductsImageLang () {
      return (product, type) => {
        if (product !== null) {
          if (type === 'onlyImage') {
            if (this.multiLanguage === 'spanish') {
              return product.imageProducts ? product.imageProducts : product.imageProductsEnglish;
            }
            if (this.multiLanguage === 'english') {
              return product.imageProductsEnglish ? product.imageProductsEnglish : product.imageProducts;
            }
            if (this.multiLanguage === 'french') {
              return product.imageProductsFrench ? product.imageProductsFrench : product.imageProducts;
            }
          }
          if (type === 'image') {
            if (this.multiLanguage === 'spanish') {
              return product.image ? product.image : product.imageEnglish;
            }
            if (this.multiLanguage === 'english') {
              return product.imageEnglish ? product.imageEnglish : product.image;
            }
            if (this.multiLanguage === 'french') {
              return product.imageFrench ? product.imageFrench : product.image;
            }
          }
        } else {
          return null;
        }
      };
    },
    getProductNameByLang () {
      return (product, type) => {
        if (product !== null) {
          if (this.multiLanguage === 'spanish') {
            return product.name ? product.name : product.nameEnglish;
          }
          if (this.multiLanguage === 'english') {
            return product.nameEnglish ? product.nameEnglish : product.name;
          }
          if (this.multiLanguage === 'french') {
            return product.nameFrench ? product.nameFrench : product.name;
          }
        } else {
          return null;
        }
      };
    },
    getProductDescriptionByLang () {
      return (product, type) => {
        if (product !== null) {
          if (this.multiLanguage === 'spanish') {
            return product.description ? product.description : product.descriptionEnglish;
          }
          if (this.multiLanguage === 'english') {
            return product.descriptionEnglish ? product.descriptionEnglish : product.description;
          }
          if (this.multiLanguage === 'french') {
            return product.descriptionFrench ? product.descriptionFrench : product.description;
          }
        } else {
          return null;
        }
      };
    },
    getNameDescriptionCategorySubcategoryByLang () {
      return (categorySubcategory, type) => {
        if (categorySubcategory !== null) {
          if (type === 'name') {
            if (this.multiLanguage === 'spanish') {
              return categorySubcategory.subCategoryName ? categorySubcategory.subCategoryName : categorySubcategory.subCategoryNameEnglish;
            }
            if (this.multiLanguage === 'english') {
              return categorySubcategory.nameEnglish ? categorySubcategory.nameEnglish : categorySubcategory.subCategoryName;
            }
            if (this.multiLanguage === 'french') {
              return categorySubcategory.nameFrench ? categorySubcategory.nameFrench : categorySubcategory.subCategoryName;
            }
          }
          if (type === 'description') {
            if (this.multiLanguage === 'spanish') {
              return categorySubcategory.subCategoryDescription ? categorySubcategory.subCategoryDescription : categorySubcategory.descriptionEnglish;
            }
            if (this.multiLanguage === 'english') {
              return categorySubcategory.descriptionEnglish ? categorySubcategory.descriptionEnglish : categorySubcategory.subCategoryDescription;
            }
            if (this.multiLanguage === 'french') {
              return categorySubcategory.descriptionFrench ? categorySubcategory.descriptionFrench : categorySubcategory.subCategoryDescription;
            }
          }
        } else {
          return null;
        }
      };
    },
    getAvailableLang () {
      return (value) => {
        const arrayLangs = this.params.availableLanguages.split(',');
        if (arrayLangs.find(lang => lang === value)) {
          return true;
        }
        return false;
      };
    }
  },
  methods: {
    getDietaryRestrictions () {
      MainApi.get(`admin/menuCustom/DietaryRestrictions/${this.params.vendorId}`).then((data) => {
        const restrictions = data.data.data;
        this.restrictions = [];
        restrictions.forEach((restriction) => {
          if (restriction.active) {
            this.restrictions.push(restriction);
          }
        });
      }).catch((e) => {
        console.error(e);
      });
    },
    setTypeLanguageMenu (type) {
      this.$store.commit(globalTypes.mutations.setMultiLanguage, type);
    },
    getViewMenusLanguage () {
      this.$http
        .get(`menuView/menu/${this.params.vendorId}/menu/${this.menuId}`)
        .then(({ data }) => {
          data.data.forEach((e, i) => {
            e.products = [];
            e.categories.sort((a, b) => {
              return parseInt(a.order) - parseInt(b.order);
            });
            e.fontButton = JSON.parse(e.fontButton);
            e.fontDescriptionCategory = e.fontDescriptionCategory !== undefined ? JSON.parse(e.fontDescriptionCategory) : null;
            e.fontSubCategory = JSON.parse(e.fontSubCategory);
            e.fontProduct = JSON.parse(e.fontProduct);
            e.fontProductDescription = JSON.parse(e.fontProductDescription);
            e.fontProductPrice = JSON.parse(e.fontProductPrice);
            this.colorArrows(e.colorArrowMoreCategories, i);
          });
          this.customMenus = data.data;
          if (this.customMenus.length > 0) {
            this.changeCategoty(
              this.customMenus[0].categories[0]._id,
              this.customMenus[0].categories[0].typeCategory,
              0,
              this.customMenus[0].buttonColorBorder,
              0,
              this.customMenus[0].buttonColorLetter
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    backgroundScreen (customMenu) {
      if (customMenu.typeBackground === 1) {
        if (
          customMenu.backgroundImage === '' ||
          customMenu.backgroundImage === null
        ) {
          return `url(${customMenu.backgroundImage}) ${(customMenu.backgroundColor === '' || customMenu.backgroundColor === null) ? 'none' : customMenu.backgroundColor}`;
        } else {
          return `url(${customMenu.backgroundImage})`;
        }
      } else {
        return (customMenu.backgroundColor === '' || customMenu.backgroundColor === null) ? 'none' : customMenu.backgroundColor;
      }
    },
    changeCategory (idCategory, type, i, colorBorder, id, colorLetter) {
      this.$http
        .get(`menuView/products/${idCategory}/${type}`)
        .then(({ data }) => {
          data.data.length > 0 &&
            data.data.sort((a, b) => {
              if (a.subCategoryName === '' || b.subCategoryName === '') {
                return -1;
              } else {
                return parseInt(a.order) - parseInt(b.order);
              }
            });
          this.productsRecommended = [];
          if (data.data.length > 0) {
            data.data.forEach(element => {
              if (element.products.length > 0) {
                element.products.forEach(product => {
                  if (product.recommended === 1) {
                    this.productsRecommended.push(product);
                  }
                });
              }
            });
          }
          if (this.customMenus[i].categories.length > 1) {
            const el = document.querySelector('.container_categories');
            if (el) {
              const maxScrollLeft = el.scrollWidth - el.clientWidth;
              if (maxScrollLeft > 0) {
                el.classList.add('width_80');
              }
              if (el.scrollLeft === 0) {
                this.rowLeft = false;
              } else {
                this.rowLeft = true;
              }
              if (maxScrollLeft <= el.scrollLeft) {
                this.rowRight = false;
              } else {
                this.rowRight = true;
              }
              if (colorLetter === null || colorLetter === undefined) {
                colorLetter = '#000000';
              }
              this.customMenus[i].categories.forEach((e, ix) => {
                if (document.getElementById(
                  'buttonCategory-' + ix
                )) {
                  document.getElementById(
                    'buttonCategory-' + ix
                  ).style.color = `${colorLetter}`;
                  document.getElementById(
                    'buttonCategory-' + ix
                  ).style.borderBottom = 'none';
                }
              });
              document.getElementById(
                'buttonCategory-' + id
              ).style.color = `${colorBorder}`;
              document.getElementById(
                'buttonCategory-' + id
              ).style.borderBottom = `3px solid ${colorBorder}`;
            }
          }
          this.customMenus[i].products = data.data;
          const category = this.customMenus[i].categories.find(
            (e) => e._id === idCategory
          );
          if (category !== undefined) {
            this.imagePriceOne = {
              imagePriceOne: category.imagePriceOne,
              imagePriceOneEnglish: category.imagePriceOneEnglish,
              imagePriceOneFrench: category.imagePriceOneFrench
            };
            this.imagePriceTwo = {
              imagePriceTwo: category.imagePriceTwo,
              imagePriceTwoEnglish: category.imagePriceTwoEnglish,
              imagePriceTwoFrench: category.imagePriceTwoFrench
            };
            this.bannerCategory = category.imageBanner;
            this.descriptionCategory = {
              description: category.description,
              descriptionEnglish: category.descriptionEnglish,
              descriptionFrench: category.descriptionFrench
            };
            this.isTwoPrices = category.twoPrices === 1;
          }
          this.viewIcons = false;
          if (this.customMenus[i].products[0] !== undefined) {
            this.customMenus[i].products[0].products.forEach(element => {
              if (element.isImage === '0' || element.isImage === 0 || element.isImage === undefined || element.isImage === null) {
                this.viewIcons = true;
              }
            });
            this.customMenus[i].products[0].products = this.customMenus[i].products[0].products.sort(function (a, b) {
              if (parseInt(a.order) > parseInt(b.order)) {
                return 1;
              }
              if (parseInt(a.order) < parseInt(b.order)) {
                return -1;
              }
              return 0;
            });
          }
        });
    },
    colorArrows () {
      try {
        this.customMenus.forEach((e) => {
          const left = document.getElementsByClassName('mdi-icon-arrow-left-cm');
          const right = document.getElementsByClassName(
            'mdi-icon-arrow-right-cm'
          );
          if (left.length > 0) {
            left[0].style.background = e.colorArrowMoreCategories;
          }
          if (right.length > 0) {
            right[0].style.background = e.colorArrowMoreCategories;
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    centerSelected (event) {
      const idElement = event.target.id;
      document.getElementById(idElement).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
      const el = document.querySelector('.container_categories');
      setTimeout(() => {
        this.scrollLeft = el.scrollLeft;
      }, 200);
    },
    scrollCategories (direction) {
      const el = document.querySelector('.container_categories');
      if (el !== undefined) {
        const maxScrollLeft = el.scrollWidth - el.clientWidth;
        if (direction === 'left') {
          this.scrollLeft = this.scrollLeft - 70;
          el.scrollLeft = this.scrollLeft;
          el.scrollTop = 0;
          if (el.scrollLeft !== this.scrollLeft) {
            this.scrollLeft = el.scrollLeft;
          }
        } else {
          this.scrollLeft += 70;
          el.scrollLeft = this.scrollLeft;
          el.scrollTop = 0;
          if (el.scrollLeft !== this.scrollLeft) {
            this.scrollLeft = el.scrollLeft;
          }
        }
        if (el.scrollLeft === 0) {
          this.rowLeft = false;
        } else {
          this.rowLeft = true;
        }
        if (maxScrollLeft <= el.scrollLeft) {
          this.rowRight = false;
        } else {
          this.rowRight = true;
        }
      }
    },
    openImage (img) {
      if (img) {
        var instance = this;
        this.$buefy.modal.open({
          parent: instance,
          props: {
            img: img
          },
          component: modalMenuImg,
          canCancel: false
        });
      }
    },
    scrollingCategories () {
      const el = document.querySelector('.container_categories');
      if (el !== undefined) {
        const maxScrollLeft = el.scrollWidth - el.clientWidth;
        if (el.scrollLeft === 0) {
          this.rowLeft = false;
        } else {
          this.rowLeft = true;
        }
        if (maxScrollLeft <= el.scrollLeft) {
          this.rowRight = false;
        } else {
          this.rowRight = true;
        }
      }
    },
    menuCustom (index, fonts) {
      const styleTag = document.createElement('style');
      styleTag.lang = 'scss';
      styleTag.type = 'text/css';
      styleTag.id = 'menu-' + index;
      styleTag.innerHTML = `
        ${this.fontTypeBody(true, fonts)}
        ${this.fontTypeBody(false, fonts.fontButton)}
        ${this.fontTypeBody(false, fonts.fontDescriptionCategory)}
        ${this.fontTypeBody(false, fonts.fontSubCategory)}
        ${this.fontTypeBody(false, fonts.fontProduct)}
        ${this.fontTypeBody(false, fonts.fontProductDescription)}
        ${this.fontTypeBody(false, fonts.fontProductPrice)}
        .custom-menu-${index}{
          background: ${this.backgroundScreen(fonts)} fixed;
          background-position: top center;
          background-size: cover;
          background-repeat: no-repeat;
        }
        .custom-menu-${index} .list-title-category-border{
          border-bottom: 1px solid ${fonts.lineSeparateSubCategories}
        }
        .custom-menu-${index} .button-custom{
          font-family : '${fonts.fontButton.fontName}';
          font-weight : ${fonts.fontButton.fontWeight};
          font-style  : ${fonts.fontButton.fontStyle};
          color       : ${fonts.buttonColorLetter};
          font-size   : ${fonts.fontButton.fontSize !== undefined && fonts.fontButton.fontSize !== null ? fonts.fontButton.fontSize + 'px' : '14px'};
        }
        .custom-menu-${index} .title-sub-category{
          font-family: '${fonts.fontSubCategory.fontName}';
          font-weight: ${fonts.fontSubCategory.fontWeight};
          font-style : ${fonts.fontSubCategory.fontStyle};
          color      : ${fonts.colorLetterSubcategories};
          font-size  : ${fonts.fontSubCategory.fontSize !== undefined && fonts.fontSubCategory.fontSize !== null ? fonts.fontSubCategory.fontSize + 'px' : '15px'};
        }
        .custom-menu-${index} .description-subcategory{
          font-family: '${fonts.fontSubCategory.fontName}';
          font-weight: ${fonts.fontSubCategory.fontWeight};
          font-style : ${fonts.fontSubCategory.fontStyle};
          color      : ${fonts.colorLetterSubcategories};
          font-size  : ${fonts.fontSubCategory.fontSize !== undefined && fonts.fontSubCategory.fontSize !== null ? fonts.fontSubCategory.fontSize + 'px' : '15px'};
        }
        .custom-menu-${index} .title-product{
          font-family: '${fonts.fontProduct.fontName}';
          font-weight: ${fonts.fontProduct.fontWeight};
          font-style : ${fonts.fontProduct.fontStyle};
          color      : ${fonts.colorLetterProductName};
          font-size  : ${fonts.fontProduct.fontSize !== undefined && fonts.fontProduct.fontSize !== null ? fonts.fontProduct.fontSize + 'px' : '13px'};
        }
        .custom-menu-${index} .description-product{
          font-family: '${fonts.fontProductDescription.fontName}';
          font-weight: ${fonts.fontProductDescription.fontWeight};
          font-style : ${fonts.fontProductDescription.fontStyle};
          color      : ${fonts.colorLetterProductDescription};
          font-size  : ${fonts.fontProductDescription.fontSize !== undefined && fonts.fontProductDescription.fontSize !== null ? fonts.fontProductDescription.fontSize + 'px' : '12px'};
        }
        .dietaryRestrictions{
          color      : ${fonts.colorLetterProductDescription};

        }

                  .logoDietaryRestrictions{
            background-color:${fonts.colorLetterProductDescription};
          }
        .custom-menu-${index} .price-product{
          font-family: '${fonts.fontProductPrice.fontName}';
          font-weight: ${fonts.fontProductPrice.fontWeight};
          font-style : ${fonts.fontProductPrice.fontStyle};
          color      : ${fonts.colorLetterProductPrice};
          font-size  : ${fonts.fontProductPrice.fontSize !== undefined && fonts.fontProductPrice.fontSize !== null ? fonts.fontProductPrice.fontSize + 'px' : '12px'};
        }
        .custom-menu-${index} .icon_products{
          background-color: ${fonts.colorIconRecommended !== null &&
          fonts.colorIconRecommended !== undefined ? fonts.colorIconRecommended : '#000000'}
        }
        .custom-menu-${index} .category_icon{
          background-color: ${fonts.colorIconRecommendedCategory !== null &&
          fonts.colorIconRecommendedCategory !== undefined ? fonts.colorIconRecommendedCategory : '#000000'}
        }
        `;
      if (fonts.fontDescriptionCategory !== null) {
        styleTag.innerHTML += `
          .custom-menu-${index} .description-category{
            font-family : '${fonts.fontDescriptionCategory.fontName}';
            font-weight : ${fonts.fontDescriptionCategory.fontWeight};
            font-style  : ${fonts.fontDescriptionCategory.fontStyle};
            color       : ${fonts.colorLetterDescription};
            font-size   : ${fonts.fontDescriptionCategory.fontSize !== undefined && fonts.fontDescriptionCategory.fontSize !== null ? fonts.fontDescriptionCategory.fontSize + 'px' : '12px'};
          }`;
      }
      document.getElementsByTagName('head')[0].appendChild(styleTag);
      return `custom-menu-${index}`;
    },
    fontTypeBody (type, font) {
      if (font !== null) {
        if (font.typeTypography === 'archive') {
          return `@font-face{
            src: url(${type ? font.typography : font.typoGraphy});
            font-family: '${font.fontName}';
          }`;
        }
        return `@import url(${type ? font.typography : font.typoGraphy});`;
      }
      return '';
    },
    getViewMenus () {
      this.$http
        .get(`menuView/menu/${this.params.vendorId}`)
        .then(({ data }) => {
          data.data.forEach((e, i) => {
            /* console.log(e); */
            e.products = [];
            e.categories.sort((a, b) => {
              return parseInt(a.order) - parseInt(b.order);
            });
            e.fontButton = JSON.parse(e.fontButton);
            e.fontDescriptionCategory = e.fontDescriptionCategory !== undefined && e.fontDescriptionCategory !== '' ? JSON.parse(e.fontDescriptionCategory) : null;
            e.fontSubCategory = JSON.parse(e.fontSubCategory);
            e.fontProduct = JSON.parse(e.fontProduct);
            e.fontProductDescription = JSON.parse(e.fontProductDescription);
            e.fontProductPrice = JSON.parse(e.fontProductPrice);
            this.colorArrows(e.colorArrowMoreCategories, i);
          });
          if (this.menuId !== undefined && this.menuId !== null) {
            const index = data.data.filter((x) => x._id === this.menuId);
            this.customMenus = index;
          } else {
            this.customMenus = data.data;
          }
          if (this.customMenus.length > 0) {
            this.changeCategory(
              this.customMenus[0].categories[0]._id,
              this.customMenus[0].categories[0].typeCategory,
              0,
              this.customMenus[0].buttonColorBorder,
              0,
              this.customMenus[0].buttonColorLetter
            );
          }
        });
    },
    deleteElement () {
      const link = document.getElementsByClassName('menuDigital');
      if (link.length > 0) {
        for (let i = 0; i <= link.length; i++) {
          link[i].remove();
        }
      }
    },
    textFormat (text = '') {
      if (text !== null) {
        if (String(text).includes('\\n')) {
          const interLine = text.replaceAll(/\\n/g, '<br/>');
          return interLine;
        } else {
          return text;
        }
      } else {
        return text;
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/styles/menuCustom/styles.scss";
</style>
